import { IContextualMenuItem, PanelType, SelectionMode } from '@fluentui/react';
import { ACDataTablePage, DataTableRequest, IDataTablesResponse } from '@ioip/core/lib';
import { useForceUpdate } from '@ioip/core/lib/hooks/useForceState';
import { Guid, IDictionary, paginateDataAsync } from '@ioip/core/lib/utilities';
import React, { useEffect, useRef, useState } from 'react';
import { useProcesox } from '../../providers';
import { ControlType, CForm } from '../../types';
import CDataTable from '../types/CDataTable';
import { IPFieldProps } from '../../types/field-props';
import { UXChildForm } from './UXChildForm';

export const UXDataTable = (props: IPFieldProps<CDataTable>): JSX.Element => {

    const procesox = useProcesox();
    const dtRefresh = useRef<() => void>(null);
    const forceUpdate = useForceUpdate();
    const [ commandBarItems, setCommandBarItems ] = useState<IContextualMenuItem[]>([]);
    const [ sub, setSub ] = useState<{ form: CForm, isUpdate: boolean }>(null);
    const columns = [ ...props.field.columns.where(x => x.visible).select(x => x.fluentUi).toArray() ];
    const [ selectedItems, setSelectedItems ] = useState<IDictionary<any>[]>([])
    const disabled = props.field.readonly || props.field.disabled;
    const isEntityDataTable = props.field.controlType == ControlType.entityDataTable;

    useEffect(() => {

        const result: IContextualMenuItem[] = [];

        if (!disabled) {
            if (props.field.permissionLevel) {
                result.push({
                    key: 'new',
                    name: disabled ? 'Ver' : 'Nuevo',
                    iconProps: { iconName: disabled ? 'View' : 'Add' },
                    disabled: props.field.formId == null,
                    title: props.field.formId != null ? 'Crear elemento' : 'No existe un formulario de edición y creación de elementos',
                    onClick: () => {
                        const form = props.field.getForm();
                        form.onInvokeRender = forceUpdate;
                        form.readonly = disabled;
                        setSub({ form, isUpdate: false });
                    }
                });
            }
        }

        if (selectedItems?.length > 0) {

            if (selectedItems.length === 1) {
                result.push({
                    key: 'edit',
                    name: disabled ? 'Ver' : 'Editar',
                    iconProps: { iconName: disabled ? 'View' : 'Edit' },
                    onClick: () => {

                        const form = props.field.getForm();
                        form.values = selectedItems[ 0 ];
                        form.onInvokeRender = forceUpdate;
                        form.readonly = disabled;
                        setSub({ form, isUpdate: true });

                    }
                });
            }

            if (!disabled) {
                result.push({
                    key: 'remove',
                    name: 'Eliminar',
                    iconProps: { iconName: 'Delete' },
                    onClick: () => {
                        const values = (props.field.value as IDictionary<any>[])?.slice() || [];
                        const selectedKeys = selectedItems.map(x => x.__key__);
                        props.field.value = values.filter((x: { __key__: any; }) => !selectedKeys.includes(x.__key__));
                        dtRefresh.current();
                    }
                });
            }

        }

        // Renderizar items configurados en el control
        // const items: IContextualMenuItem[] = props.field.CommandBarItems?.GetVisibleItems(selectedItems) || [];
        // result.push(...items);

        setCommandBarItems(result);


    }, [ selectedItems ]);

    const onDownloadServerDataAsync = async (request: DataTableRequest): Promise<IDataTablesResponse<any>> => {
        if (isEntityDataTable) {
            const response = await procesox.executeEntityDataTableAsync(props.field.form.objectId, props.field.id, request)
            return response;
        } else {
            return await paginateDataAsync<any>(request, {
                data: () => props.field.value as any ?? [],
                search: (o) => []
            });
        }
    }

    return <>
        <div style={{ maxHeight: '400px' }}>
            <ACDataTablePage<any>
                //classNames={{ title: 'default-table-title', }}
                columns={columns}
                compact={true}
                onGetKey={x => x.IdPoblacion as number}
                onSelectionChanged={setSelectedItems}
                selectedItems={selectedItems || []}
                selectionMode={props.field.selectionMode || SelectionMode.single}
                onDownloadServerDataAsync={onDownloadServerDataAsync}
                commandBarItems={commandBarItems}
                title={props.field.title}
                commandBarFarItems={[]}
                refreshRef={x => dtRefresh.current = x}
            />
        </div>
        {sub != null && <UXChildForm
            panelTitle={props.field?.panelTitle || ''}
            panelType={props.field?.panelType || PanelType.medium}
            onClose={() => setSub(null)}
            onAccept={() => {

                // Actualizar o agregar el registro
                const rows = (props.field.value as IDictionary<any>[])?.slice() || [];
                if (sub.isUpdate) {

                    // Actualizar los valores del formulario y restablecer la clave primaria para evitar que se pierda, puesto
                    // que este valor es clave en el servidor
                    const index = rows.findIndex((x: { __key__: any; }) => x.__key__ == sub.form.key);
                    const primaryKey = rows[ index ][ Guid.empty.toString() ];
                    rows[ index ] = sub.form.values;
                    rows[ index ][ Guid.empty.toString() ] = primaryKey;
                    props.field.value = rows;

                } else {

                    const formValues = sub.form.values;
                    (formValues as any)[ '__key__' ] = Guid.newGuid().toString();
                    rows.push(formValues);
                    props.field.value = rows;

                }

                dtRefresh.current();

            }}
            form={sub.form}
            show={sub != null}
            sdk={procesox}
            customComponents={props.customComponents}
        />}

    </>

}